import { Link } from '@tanstack/react-router';
import { ArrowLeft } from 'lucide-react';

/**
 * Shared "you can't see this integration" page. Rendered both when an
 * integration id doesn't exist and when the current user lacks the permission
 * to view/manage it. Pass `id` for the not-found-or-no-access wording; omit it
 * for a plain no-access message.
 */
export function IntegrationNoAccess({ id }: { id?: string }) {
  return (
    <div className="flex-1 overflow-auto">
      <div className="p-6 max-w-4xl mx-auto space-y-6">
        <Link
          to="/settings"
          className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to Settings
        </Link>
        <div>
          <h1 className="text-2xl font-semibold tracking-tight text-foreground">
            Integration not available
          </h1>
          <p className="text-sm text-muted-foreground mt-1">
            {id ? (
              <>
                The integration &ldquo;{id}&rdquo; does not exist or you don&rsquo;t have access to
                it.
              </>
            ) : (
              <>You don&rsquo;t have access to this integration.</>
            )}
          </p>
        </div>
      </div>
    </div>
  );
}
